"use strict";
module.exports = {
    STORYBLOK_TOKENS: {
        QA: "O5iNnduumLUeBTEXgAUvRgtt",
        STAGING: "gH2jxeroVxBkGa6Uvekv1wtt",
        PRODUCTION: "YngyYOiNVuwhQx0qf0oynQtt"
    }
};



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/utils/fdr/storyblok.js